var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","rounded":"","width":"100%","max-width":"400px"}},[_c('v-card-text',[_c('v-alert',{staticClass:"message-wrapper error-message",attrs:{"transition":"scale-transition","icon":"$alert"}},[_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t("loadingDataFailed"))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }